import React, { useEffect, useContext } from 'react';

import { Box, Card, CardContent, Typography, Modal, IconButton, Grid, Button } from '@mui/material';
import { withRouter } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import CloseIconIMG from '../../images/Icon.svg';
import { ProductQuestionModalStyle as classes } from './ProductQuestionModalStyles';
import LeadGenerationContext from '../../context/LeadGenerationContext';
import {
  CLOSE,
  PRODUCT_KEY_TEXTONE,
  MODAL_PRODUCT_CONTENT,
  PRODUCT_KEY_TEXTTWO,
  MODALTEXTHEADING,
} from '../../constants';
import { CloseIcon } from '../../images/svg/CustomizedSVG';

function ProductQuestionModal(props) {
  const { t } = useTranslation();
  const [open, setOpen] = React.useState(false);
  const leadGenerationContext = useContext(LeadGenerationContext);
  const { theme } = leadGenerationContext;
  const { openModal } = props;

  const handleClose = () => {
    leadGenerationContext.setOpenProductQuestionModal(false);
    setOpen(false);
  };

  useEffect(() => {
    if (openModal) setOpen(true);
    else setOpen(false);
  }, [openModal]);

  const textOne = MODALTEXTHEADING;
  const textTwo = MODAL_PRODUCT_CONTENT;

  return (
    <Modal
      sx={classes.backdrop}
      BackdropProps={{
        style: {
          backgroundColor: 'rgba(233, 233, 235, 0.78)',
        },
      }}
      open={open}
      role="dialog"
      aria-describedby="dialog1Desc dialog2Desc"
    >
      <Box component="div" sx={classes.productmodal}>
        <Grid container sx={classes.productmodalcontainer}>
          <Grid item size={{ sm: 1.5, xs: 1.5, lg: 1.5, md: 1.5 }}>
            <IconButton
              src={CloseIconIMG}
              name="closeicon"
              onClick={handleClose}
              tabIndex="0"
              data-testid="close_id"
              id="businessAddressEdit"
              disableRipple
              sx={classes.closeOverlay}
            >
              {/* <img
                alt={t('close', { defaultValue: 'close' })}
                src={CloseIconIMG}
                width="20px"
                height="20px"
              /> */}
              <CloseIcon height="20px" width="20px" color={theme?.palette?.orientalPrimary?.main} />
            </IconButton>
          </Grid>
        </Grid>
        <Grid container>
          <Card sx={{ ...classes.root, background: theme?.customBackground }}>
            <CardContent sx={classes.card_content}>
              <Typography
                sx={classes.textOneStyle}
                color="primary"
                variant="subtitle1"
                component="p"
                id="dialog1Desc"
              >
                {t(PRODUCT_KEY_TEXTONE, { defaultValue: textOne })}
              </Typography>
              <Typography
                color="primary"
                variant="subtitle1"
                component="p"
                sx={classes.textTwoStyle}
                id="dialog2Desc"
              >
                {t(PRODUCT_KEY_TEXTTWO, { defaultValue: textTwo })}
              </Typography>
              <div style={{ width: '100%' }}>
                <Button
                  disableFocusRipple
                  autoFocus
                  sx={{
                    ...classes.saveAndExit,
                    color: '#FFFFFF',
                    backgroundColor: theme?.palette?.orientalPrimary?.main,
                    border: `1.6px solid ${theme?.palette?.orientalPrimary?.main}`,
                    ':focus': {
                      outline: `2px solid ${theme?.palette?.orientalPrimary?.main}`,
                      outlineOffset: '2px',
                    },
                    ':hover': {
                      backgroundColor: theme?.palette?.orientalPrimary?.main,
                    },
                  }}
                  data-testid="CloseButtonInProductModal"
                  onClick={handleClose}
                >
                  {t(CLOSE, { defaultValue: CLOSE })}
                </Button>
              </div>
            </CardContent>
          </Card>
        </Grid>
      </Box>
    </Modal>
  );
}

ProductQuestionModal.propTypes = {
  openModal: PropTypes.bool,
};

export default withRouter(ProductQuestionModal);
